// All translatable strings live here. Add a new key to BOTH ar and en blocks.
export const translations = {
    ar: {
        direction: "rtl",
        switchTo: "EN",

        nav: {
            features: "المميزات",
            how: "كيف يعمل",
            stats: "إحصائيات",
            testimonials: "الآراء",
        },
        header: { cta: "حمّل الآن" },

        hero: {
            badge: "متوفر الآن للتحميل",
            h1Top: "حوّل جسمك.",
            h1Bottom: "غيّر حياتك.",
            sub:
                "مدربك الشخصي بالذكاء الاصطناعي — تمارين مخصصة، تغذية ذكية، ونتائج حقيقية من جوالك.",
            learnMore: "اكتشف المميزات",
            aiSupported: "مدعوم بالـ AI",
            scroll: "SCROLL",
        },

        download: { from: "حمّل من" },

        features: {
            eyebrow: "FEATURES",
            h2Top: "كل اللي تحتاجه",
            h2Bottom: "في تطبيق واحد.",
            desc:
                "أدوات احترافية مصممة بدقّة لتعطيك تجربة لياقة كاملة من جوالك — تمارين، تغذية، تتبع، وفيديوهات.",
            items: {
                ai: {
                    title: "مدرب ذكاء اصطناعي شخصي",
                    desc: "ذكاء اصطناعي يحلل أداءك ويعدّل خططك يوماً بيوم لتصل لهدفك أسرع.",
                },
                workouts: {
                    title: "برامج تمارين مخصصة",
                    desc: "خطط بناء عضل، حرق دهون، وكارديو — كلها مفصّلة على مستواك.",
                },
                progress: {
                    title: "تتبع التقدم والإحصائيات",
                    desc: "رسومات بيانية مباشرة لوزنك، قوّتك، ودقات قلبك.",
                },
                nutrition: {
                    title: "خطط غذائية ذكية",
                    desc: "وجبات يومية محسوبة بالسعرات والماكروز حسب هدفك.",
                },
                videos: {
                    title: "فيديوهات تمارين احترافية",
                    desc: "مكتبة فيديو HD تشرح كل تمرين بالحركة والتنفس الصحيح.",
                },
            },
        },

        how: {
            eyebrow: "HOW IT WORKS",
            h2Top: "ابدأ في",
            h2Bottom: "3 خطوات.",
            desc:
                "ما تحتاج خبرة. التطبيق يأخذك خطوة بخطوة من أول تثبيت إلى أول إنجاز حقيقي.",
            steps: [
                {
                    n: "01",
                    title: "حمّل التطبيق",
                    desc: "متوفر على آب ستور، قوقل بلاي، وهواوي آب قاليري.",
                },
                {
                    n: "02",
                    title: "حدّد هدفك",
                    desc: "بناء عضل، حرق دهون، أو لياقة عامة — أنت تختار.",
                },
                {
                    n: "03",
                    title: "ابدأ التحوّل",
                    desc: "نتائج خلال أسابيع مع متابعة يومية ودعم مستمر.",
                },
            ],
        },

        stats: {
            items: [
                { value: "50K+", label: "عضو نشط" },
                { value: "1.2M", label: "تمرين مكتمل" },
                { value: "98%", label: "نسبة الرضا" },
                { value: "24/7", label: "دعم ومتابعة" },
            ],
        },

        testimonials: {
            eyebrow: "REAL STORIES",
            h2Top: "نتائج حقيقية.",
            h2Bottom: "من ناس مثلك.",
            items: [
                {
                    name: "خالد العتيبي",
                    role: "خسر 18 كيلو خلال 4 شهور",
                    quote:
                        "أفضل تطبيق جربته. البرنامج تغيّر معاي مع تقدّمي والـ AI فعلاً يفهم وضعي.",
                },
                {
                    name: "نورة الشمري",
                    role: "بناء عضل ولياقة",
                    quote:
                        "الفيديوهات واضحة والوجبات لذيذة وعملية. صرت أتمرّن بثقة وبدون مدرب.",
                },
                {
                    name: "محمد القحطاني",
                    role: "لاعب كرة قدم",
                    quote:
                        "تتبع الإحصائيات والأداء غيّر طريقتي بالكامل. النتائج بانت بسرعة.",
                },
            ],
        },

        cta: {
            h2Top: "جاهز",
            h2Bottom: "للتحدّي؟",
            desc:
                "حمّل 606FITNESS اليوم وابدأ رحلتك نحو نسخة أقوى منك. متوفر على جميع الأجهزة.",
        },

        account: {
            pageTitle: "إدارة الحساب",
            pageSubtitle: "Account Management",
            intro:
                "من هنا تقدر تنزّل نسخة من بياناتك أو تحذف حسابك نهائياً من 606FITNESS. سجّل دخولك أولاً للمتابعة.",
            loginH: "تسجيل الدخول",
            email: "البريد الإلكتروني",
            password: "كلمة المرور",
            loginBtn: "دخول",
            forgot: "نسيت كلمة المرور؟",
            backToLogin: "رجوع لتسجيل الدخول",

            forgotH: "إعادة تعيين كلمة المرور",
            forgotIntro:
                "أدخل بريدك الإلكتروني وسنرسل لك رمز تحقق لتعيين كلمة مرور جديدة.",
            sendCode: "إرسال رمز التحقق",
            code: "رمز التحقق",
            newPassword: "كلمة المرور الجديدة",
            resetBtn: "تعيين كلمة المرور",
            codeSent: "تم إرسال رمز التحقق إلى بريدك.",

            loggedInAs: "مسجّل دخولك بـ",
            myData: "بياناتي",
            downloadData: "تنزيل بياناتي (JSON)",
            dataDescription:
                "هذه نسخة كاملة من بيانات حسابك في 606FITNESS. تقدر تحفظها كملف JSON.",

            dangerZone: "منطقة الخطر",
            deleteH: "حذف الحساب نهائياً",
            deleteWarning:
                "تحذير: حذف الحساب نهائي ولا يمكن التراجع عنه. ستفقد كل بياناتك (الملف الشخصي، التمارين، الخطط، التقدّم، الاشتراكات، ومحادثات المدرّب الذكي) بشكل دائم.",
            confirmInstruction:
                "اكتب كلمة DELETE بحروف كبيرة في الخانة أدناه للتأكيد:",
            confirmPlaceholder: "اكتب DELETE",
            reasonOptional: "سبب الحذف (اختياري)",
            deleteBtn: "حذف حسابي نهائياً",
            cancel: "إلغاء",

            logout: "تسجيل خروج",

            successDeleted:
                "تم حذف حسابك بنجاح. ستفتقدك عائلة 606FITNESS!",
            successDownloaded: "تم تنزيل بياناتك بنجاح.",

            errors: {
                generic: "حدث خطأ غير متوقع. حاول مرة ثانية.",
                invalidCredentials: "البريد أو كلمة المرور غير صحيحة.",
                network: "تعذّر الاتصال بالخادم. تأكد من اتصالك بالإنترنت.",
                confirmRequired: "يجب كتابة كلمة DELETE بالضبط للتأكيد.",
                emailRequired: "البريد الإلكتروني مطلوب.",
                passwordRequired: "كلمة المرور مطلوبة.",
            },
        },

        store: {
            eyebrow: "IN-APP STORE",
            h2Top: "متجر 606FITNESS",
            h2Bottom: "كل ما تحتاجه — في تطبيقك.",
            desc:
                "اطلب معدات التمرين، الملابس الرياضية، والأحذية مباشرة من داخل التطبيق. شحن سريع وضمان جودة.",
            regionBadge: "متوفر حالياً في الإمارات العربية المتحدة",
            categories: [
                {
                    key: "equipment",
                    title: "معدات رياضية",
                    desc: "أوزان، أحبال، أجهزة كارديو وكل ما تحتاج لجيمك المنزلي.",
                },
                {
                    key: "sportswear",
                    title: "ملابس رياضية",
                    desc: "تي شيرتات، شورتات، ولباس تمرين بأقمشة عالية الأداء.",
                },
                {
                    key: "shoes",
                    title: "أحذية رياضية",
                    desc: "أحذية مخصصة للجري، الرفع، والتمرين الوظيفي.",
                },
            ],
            cta: "تعرّف على المتجر",
        },

        footer: {
            tagline:
                "حوّل جسمك. غيّر حياتك. مدرّبك الشخصي في جيبك، أينما كنت.",
            quickLinks: "روابط سريعة",
            supportLegal: "الدعم والقانون",
            copyright: "جميع الحقوق محفوظة.",
            brandTag: "BUILT FOR STRENGTH.",
            ownedBy: "التطبيق تابع لـ",
            partOf: "أحد منصات",
            legal: {
                help: "الدعم والمساعدة",
                privacy: "سياسة الخصوصية",
                terms: "شروط الاستخدام",
                medicalSources: "المصادر الطبية",
                healthDisclaimer: "تنبيه الصحة والسلامة",
                account: "إدارة / حذف الحساب",
                contact: "تواصل معنا",
            },
        },
    },

    en: {
        direction: "ltr",
        switchTo: "AR",

        nav: {
            features: "Features",
            how: "How It Works",
            stats: "Stats",
            testimonials: "Reviews",
        },
        header: { cta: "Download" },

        hero: {
            badge: "Available now",
            h1Top: "Transform your body.",
            h1Bottom: "Change your life.",
            sub:
                "Your AI personal trainer — tailored workouts, smart nutrition, and real results, all from your phone.",
            learnMore: "Discover features",
            aiSupported: "Powered by AI",
            scroll: "SCROLL",
        },

        download: { from: "Get it on" },

        features: {
            eyebrow: "FEATURES",
            h2Top: "Everything you need",
            h2Bottom: "in one app.",
            desc:
                "Professional tools precisely designed to deliver a complete fitness experience — workouts, nutrition, tracking, and videos.",
            items: {
                ai: {
                    title: "Personal AI Coach",
                    desc: "AI that analyzes your performance and adjusts your plans daily to reach your goal faster.",
                },
                workouts: {
                    title: "Custom Workout Plans",
                    desc: "Muscle building, fat burning, and cardio plans — all tailored to your level.",
                },
                progress: {
                    title: "Progress & Stats Tracking",
                    desc: "Live charts for your weight, strength, and heart rate.",
                },
                nutrition: {
                    title: "Smart Nutrition Plans",
                    desc: "Daily meals calculated by calories and macros based on your goal.",
                },
                videos: {
                    title: "Pro Exercise Videos",
                    desc: "HD video library demonstrating every exercise with proper form and breathing.",
                },
            },
        },

        how: {
            eyebrow: "HOW IT WORKS",
            h2Top: "Start in",
            h2Bottom: "3 steps.",
            desc:
                "No experience required. The app guides you step-by-step from first install to your first real achievement.",
            steps: [
                {
                    n: "01",
                    title: "Download the App",
                    desc: "Available on App Store, Google Play, and Huawei AppGallery.",
                },
                {
                    n: "02",
                    title: "Set Your Goal",
                    desc: "Build muscle, burn fat, or general fitness — you choose.",
                },
                {
                    n: "03",
                    title: "Start Your Transformation",
                    desc: "Results in weeks with daily tracking and continuous support.",
                },
            ],
        },

        stats: {
            items: [
                { value: "50K+", label: "Active Members" },
                { value: "1.2M", label: "Workouts Done" },
                { value: "98%", label: "Satisfaction" },
                { value: "24/7", label: "Support" },
            ],
        },

        testimonials: {
            eyebrow: "REAL STORIES",
            h2Top: "Real results.",
            h2Bottom: "From people like you.",
            items: [
                {
                    name: "Khalid Al-Otaibi",
                    role: "Lost 18kg in 4 months",
                    quote:
                        "Best app I've used. The program evolved with my progress and the AI genuinely understood my situation.",
                },
                {
                    name: "Noura Al-Shammari",
                    role: "Muscle building & fitness",
                    quote:
                        "Clear videos, tasty practical meals. I now train confidently without a coach.",
                },
                {
                    name: "Mohammed Al-Qahtani",
                    role: "Football player",
                    quote:
                        "Stats and performance tracking changed my entire approach. Results showed up fast.",
                },
            ],
        },

        cta: {
            h2Top: "Ready for",
            h2Bottom: "the challenge?",
            desc:
                "Download 606FITNESS today and start your journey to a stronger you. Available on all devices.",
        },

        store: {
            eyebrow: "IN-APP STORE",
            h2Top: "606FITNESS Store",
            h2Bottom: "Everything you need — in your app.",
            desc:
                "Order training equipment, sportswear, and shoes directly from inside the app. Fast shipping and quality guarantee.",
            regionBadge: "Currently available in the United Arab Emirates",
            categories: [
                {
                    key: "equipment",
                    title: "Equipment",
                    desc: "Weights, ropes, cardio machines and everything for your home gym.",
                },
                {
                    key: "sportswear",
                    title: "Sportswear",
                    desc: "Tees, shorts, and training gear in high-performance fabrics.",
                },
                {
                    key: "shoes",
                    title: "Shoes",
                    desc: "Specialized footwear for running, lifting, and functional training.",
                },
            ],
            cta: "Explore the store",
        },

        footer: {
            tagline:
                "Transform your body. Change your life. Your personal coach in your pocket, anywhere.",
            quickLinks: "Quick Links",
            supportLegal: "Support & Legal",
            copyright: "All rights reserved.",
            brandTag: "BUILT FOR STRENGTH.",
            ownedBy: "App owned by",
            partOf: "Part of",
            legal: {
                help: "Help & Support",
                privacy: "Privacy Policy",
                terms: "Terms of Service",
                medicalSources: "Medical Sources",
                healthDisclaimer: "Health & Safety Disclaimer",
                account: "Manage / Delete Account",
                contact: "Contact Us",
            },
        },
    },
};
